import { useEffect, useState } from 'react';
import { CloudOff } from 'lucide-react';

/** A quiet, honest banner rather than silently serving stale data (§F22). */
export function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOffline(false);
    const goOffline = () => setOffline(true);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-center gap-1.5 px-3 py-1 text-[12px]"
      style={{ background: 'var(--warn)', color: '#fff' }}
    >
      <CloudOff className="size-3.5" />
      You are offline — showing the last data that reached this device. Changes will not save.
    </div>
  );
}
